import {
  Backdrop,
  Button,
  Paper,
  Typography,
  useTheme,
} from "@material-ui/core";
import { IconAlertCircle, IconCircleCheck } from "@tabler/icons-react";

interface props {
  show: boolean;
  type: "success" | "error";
  message?: string;
  onClose: () => void;
}

const CustomModalAlert = ({ show, type, onClose, message }: props) => {
  const theme = useTheme();

  const getIcon = () => {
    switch (type) {
      case "success":
        return (
          <IconCircleCheck
            color={theme.palette.success.main}
            size={92}
            strokeWidth={1.2}
          />
        );
      case "error":
        return <IconAlertCircle color="#d32f2f" size={92} strokeWidth={1.2} />;

      default:
        return <IconCircleCheck color="#20be79" size={92} strokeWidth={1.2} />;
    }
  };

  const getTitle = () => {
    switch (type) {
      case "success":
        return "Éxito";
      case "error":
        return "Error";
      default:
        return "Éxito";
    }
  };

  const getColorButton = () => {
    switch (type) {
      case "success":
        return theme.palette.success.main;
      case "error":
        return "#d32f2f";
      default:
        return "#20be79";
    }
  };

  if (!show) {
    return null;
  }

  return (
    <>
      <Backdrop open={true} style={{ zIndex: 9999 }} onClick={onClose}>
        <style>
          {`
            .modal_animation{
                animation: jello-horizontal .7s both;
            }
            @keyframes jello-horizontal{0%{transform:scale3d(1,1,1)}30%{transform:scale3d(1.25,.75,1)}40%{transform:scale3d(.75,1.25,1)}50%{transform:scale3d(1.15,.85,1)}65%{transform:scale3d(.95,1.05,1)}75%{transform:scale3d(1.05,.95,1)}100%{transform:scale3d(1,1,1)}}
        `}
        </style>
        <Paper
          elevation={4}
          className="modal_animation"
          style={{ padding: "20px 20px", minWidth: 340 }}
          onClick={(e) => e.stopPropagation()}
        >
          <div>
            <center>{getIcon()}</center>
            <br />
            <center>
              <Typography variant="h5" style={{ fontWeight: "600" }}>
                {getTitle()}
              </Typography>
            </center>
            <center>
              <Typography variant="body1" color="initial">
                {message || "..."}
              </Typography>
            </center>
            <br />
            <br />
            <center>
              <Button
                onClick={onClose}
                variant="contained"
                fullWidth
                style={{ background: getColorButton(), color: "white" }}
              >
                Aceptar
              </Button>
            </center>
          </div>
        </Paper>
      </Backdrop>
    </>
  );
};

export default CustomModalAlert;
